const DecisionBoundary = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">
            <p className="tw-header">Decision Boundary</p>
        </div>
    )
}

export default DecisionBoundary;